module.exports = __webpack_public_path__ + "img/new_family.60656155.svg";